var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBanking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 221.85,
    height: 266,
    viewBox: "0 0 221.85 266",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-0.81 -0.17)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 221.85,
    height: 266,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37,222.6V238H10.33a7.77,7.77,0,0,1-7.7-7.7,8.24,8.24,0,0,1,2.2-5.5,7.39,7.39,0,0,1,5.5-2.2Z",
    transform: "translate(-0.81 -0.17)",
    fill: "#fff",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.33,232.9a2.6,2.6,0,1,1,0-5.2h27v5.1h-27Z",
    transform: "translate(-0.81 -0.17)",
    fill: "#fffdfd",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,207.2v15.4H10.33a7.77,7.77,0,0,1-7.7-7.7,8.24,8.24,0,0,1,2.2-5.5,7.39,7.39,0,0,1,5.5-2.2Z",
    transform: "translate(-0.81 -0.17)",
    fill: "#fff",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,217.5H10.33a2.6,2.6,0,0,1,0-5.2h27",
    transform: "translate(-0.81 -0.17)",
    fill: "#f8fafc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,217.5H10.33a2.6,2.6,0,0,1,0-5.2h27",
    transform: "translate(-0.81 -0.17)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,191.6V207H10.33a7.77,7.77,0,0,1-7.7-7.7,8.24,8.24,0,0,1,2.2-5.5,7.39,7.39,0,0,1,5.5-2.2Z",
    transform: "translate(-0.81 -0.17)",
    fill: "#fff",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,201.9H10.33a2.6,2.6,0,1,1,0-5.2h27",
    transform: "translate(-0.81 -0.17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,201.9H10.33a2.6,2.6,0,1,1,0-5.2h27",
    transform: "translate(-0.81 -0.17)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,176.2v15.4H10.33a7.77,7.77,0,0,1-7.7-7.7,8.24,8.24,0,0,1,2.2-5.5,7.39,7.39,0,0,1,5.5-2.2Z",
    transform: "translate(-0.81 -0.17)",
    fill: "#fff",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,186.5H10.33a2.6,2.6,0,0,1,0-5.2h27",
    transform: "translate(-0.81 -0.17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,186.5H10.33a2.6,2.6,0,0,1,0-5.2h27",
    transform: "translate(-0.81 -0.17)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.63,161h4.6v15.4h-4.6a3.89,3.89,0,0,1-1.5-.2,7.8,7.8,0,0,1-6.2-7.5,7.64,7.64,0,0,1,6.2-7.5A3.64,3.64,0,0,1,32.63,161Z",
    transform: "translate(-0.81 -0.17)",
    fill: "#fff",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.63,166.2h4.6v5.1h-4.6a2.52,2.52,0,0,1-2.6-2.6A2.63,2.63,0,0,1,32.63,166.2Z",
    transform: "translate(-0.81 -0.17)",
    fill: "#fff",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,145.6V161H10.33a7.7,7.7,0,0,1,0-15.4Z",
    transform: "translate(-0.81 -0.17)",
    fill: "#fffffe",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.33,150.9h27v5h-27a2.52,2.52,0,0,1-2.6-2.6A2.42,2.42,0,0,1,10.33,150.9Z",
    transform: "translate(-0.81 -0.17)",
    fill: "#fff",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.13,226.9V18.6A16.69,16.69,0,0,0,168.23,2H53.83a16.82,16.82,0,0,0-16.9,16.9V246.3A16.77,16.77,0,0,0,53.83,263h114.4a16.82,16.82,0,0,0,16.9-16.9V226.9",
    transform: "translate(-0.81 -0.17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.13,226.9V18.6A16.69,16.69,0,0,0,168.23,2H53.83a16.82,16.82,0,0,0-16.9,16.9V246.3A16.77,16.77,0,0,0,53.83,263h114.4a16.82,16.82,0,0,0,16.9-16.9V226.9",
    transform: "translate(-0.81 -0.17)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.43,226.9v19.3a6.44,6.44,0,0,0,6.4,6.4h114.4a6.44,6.44,0,0,0,6.4-6.4V18.7a6.44,6.44,0,0,0-6.4-6.4H53.83a6.44,6.44,0,0,0-6.4,6.4V226.9Z",
    transform: "translate(-0.81 -0.17)",
    fill: "#fffdfd",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.37
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.53,150.9V18.7a1.32,1.32,0,0,1,1.3-1.3h114.4a1.32,1.32,0,0,1,1.3,1.3V246.1a1.32,1.32,0,0,1-1.3,1.3H53.83a1.32,1.32,0,0,1-1.3-1.3V150.9",
    transform: "translate(-0.81 -0.17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.53,150.9V18.7a1.32,1.32,0,0,1,1.3-1.3h114.4a1.32,1.32,0,0,1,1.3,1.3V246.1a1.32,1.32,0,0,1-1.3,1.3H53.83a1.32,1.32,0,0,1-1.3-1.3V150.9",
    transform: "translate(-0.81 -0.17)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.37
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.13,36.7H36.93",
    transform: "translate(-0.81 -0.17)",
    fill: "#f8fafc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.13,36.7H36.93",
    transform: "translate(-0.81 -0.17)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.13,226.9H36.93",
    transform: "translate(-0.81 -0.17)",
    fill: "#f8fafc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.13,226.9H36.93",
    transform: "translate(-0.81 -0.17)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.53,240.4h29",
    transform: "translate(-0.81 -0.17)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.33,148.7c.4-.7.7-1.7,1.1-2.4a29.91,29.91,0,0,0,1.5-4.2,3.26,3.26,0,0,0,.4-1.3l13.2-1.1V124.3l-13.2-1.1a8.8,8.8,0,0,1-.5-1.5c-.4-1.3-.7-2.4-1.1-3.7a20.36,20.36,0,0,1-.9-2.2c-.6-1.1-1.1-2.2-1.6-3.3,0-.2-.2-.4-.2-.6l7.9-9.4-11-11-9.2,7.9c-.9-.6-2-1.1-2.9-1.7a26,26,0,0,0-2.4-1.3,54.47,54.47,0,0,0-6.1-2l-1.1-13h-15.4l-1.1,13a54.12,54.12,0,0,0-6.1,2,14.14,14.14,0,0,0-2.4,1.3,13.81,13.81,0,0,0-2.9,1.7l-9.2-7.9-11,11,7.9,9.4a.73.73,0,0,0-.2.6c-.7,1.1-1.1,2.2-1.7,3.3a10.2,10.2,0,0,0-.9,2.2,11.36,11.36,0,0,0-1.1,3.7c-.2.6-.4.9-.6,1.5l-13.9,1v15.4l13.2,1.1a3.26,3.26,0,0,1,.4,1.3,26,26,0,0,0,1.5,4.2c.4.7.7,1.7,1.1,2.4.6,1.1,1.1,2.2,1.8,3.3a8.26,8.26,0,0,1,.7,1.3l-8.8,10.3,11,11,11-9.2a14.25,14.25,0,0,0,2.8,1.3,3.92,3.92,0,0,0,1.3.5,27,27,0,0,0,5.7,1.8l1.1,14.1h15.4l1.1-14.1c2-.6,3.9-1.1,5.7-1.8a3.92,3.92,0,0,1,1.3-.5,22.79,22.79,0,0,0,2.8-1.3l11,9.2,11-11-8.8-10.3a2.79,2.79,0,0,0,.7-1.3C144.23,150.9,144.73,149.8,145.33,148.7Z",
    transform: "translate(-0.81 -0.17)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.13,178.1,107,164.9l-3.7-.9a37,37,0,0,1-5-1.7c-.2,0-.4-.2-.5-.2l-.6-.2-.7-.4a6.89,6.89,0,0,1-1.5-.7l-3.1-1.7-10.1,8.4-4.2-4.2,8.3-9.7-2.2-3.3v-.2c-.2-.4-.4-.7-.6-1.1-.6-.9-1.1-1.8-1.7-2.9a8.82,8.82,0,0,1-.9-2c-.4-1.1-.7-2.2-1.3-3.7-.2-.4-.2-.7-.4-1.1v-.2l-.9-3.7-3.7-.2-8.4-.7v-5.9l12.3-1.1.9-3.7a.62.62,0,0,1,.2-.4c.2-.4.2-.7.4-.9a26.79,26.79,0,0,1,1.1-3.1c.2-.4.4-.9.6-1.3l.2-.6c.5-.9.9-2,1.5-2.9.2-.2.2-.4.4-.6l1.8-3.1L78,102.5l4.2-4.2,8.4,7.2,3.3-2c.4-.4,1.1-.5,1.7-.9.4-.2.7-.4.9-.5.4-.2.7-.4,1.1-.6a3.49,3.49,0,0,0,.9-.6,38.1,38.1,0,0,1,5.1-1.7l3.7-.9,1.1-12.1h5.9l1.1,12.1,3.7.9a23.51,23.51,0,0,1,5.1,1.7,3.49,3.49,0,0,1,.9.6c.4.2.7.4,1.1.6s.7.4.9.5a14,14,0,0,0,1.7.9l3.3,2,8.4-7.2,4.2,4.2-7.2,8.4,1.8,3.1c.2.2.2.4.4.6a13.23,13.23,0,0,1,1.5,2.9l.2.6c.2.4.4.9.6,1.3.4.9.7,2,1.1,3.1.2.4.2.7.4.9,0,.2,0,.2.2.4l.9,3.7,3.7.4,8.4.7v5.9l-12.3,1.1-.9,3.7c-.2.4-.2.7-.4,1.1a16,16,0,0,1-1.3,3.7c-.4.7-.6,1.5-.9,2-.5,1.1-1.1,2-1.5,2.8-.2.4-.4.7-.6,1.1l-.2.2-2.2,3.3,2.6,2.9,5.7,6.6-4.2,4.2-10.1-8.4-3.1,1.7a6.89,6.89,0,0,1-1.5.7l-1.1.7-.6.4c-.2,0-.4.2-.6.2a49.48,49.48,0,0,1-5,1.7l-3.7.9-1.1,13.2h-5.9v-.2Z",
    transform: "translate(-0.81 -0.17)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.33,118.8c-2-1.7-5-2.4-8.4-2.4h-11v20.9h-4v3.9h4v3.1h4v-3.1h8.6v-3.9h-8.6V135h7c3.7,0,6.4-.7,8.4-2.4a9.23,9.23,0,0,0,0-13.8Zm-3,11.4a8.22,8.22,0,0,1-5.5,1.7h-7V120h7a9.85,9.85,0,0,1,5.7,1.5,5,5,0,0,1,2,4.4A6,6,0,0,1,118.33,130.2Z",
    transform: "translate(-0.81 -0.17)",
    fill: "#71c4ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,161.4a29,29,0,1,0-29-29A29,29,0,0,0,111,161.4Z",
    transform: "translate(-0.81 -0.17)",
    fill: "none",
    stroke: "#71c4ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.33
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.53,32.4a19.88,19.88,0,0,0-6-4.8.64.64,0,0,0-.6,0,.6.6,0,0,0-.3.6.55.55,0,0,0,.3.5,17.77,17.77,0,0,1,5.7,4.5,18.11,18.11,0,0,1,4.3,13.4,17.81,17.81,0,0,1-6.4,12.5,17.35,17.35,0,0,1-10.1,4.3h-.2l-.3-4.3c0-.3-.2-.4-.4-.6a.62.62,0,0,0-.7.2l-4.2,4.6a.76.76,0,0,0-.2.4.54.54,0,0,0,.3.4l4.8,4a.59.59,0,0,0,.7.1c.2-.1.4-.4.3-.6l-.2-3h.2a19.77,19.77,0,0,0,10.8-4.6A19.52,19.52,0,0,0,211.53,32.4Zm-17.4,31.3,2.8-3,.4,5.7Z",
    transform: "translate(-0.81 -0.17)",
    fill: "#71c4ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.53,26.3l-4.8-4a.6.6,0,0,0-.4-.1.37.37,0,0,0-.3.1.45.45,0,0,0-.3.6l.2,3h-.1a19.78,19.78,0,0,0-9.6,3.6v1.6a19,19,0,0,1,9.6-4h.2l.3,4.3c0,.3.2.4.4.5s.5.1.6-.1l.1-.1,4.2-4.6a.76.76,0,0,0,.2-.4A1.38,1.38,0,0,0,200.53,26.3Zm-4.1,3.6-.4-5.7,3.1,2.6Zm-8,31.9a22,22,0,0,1-3.2-2.1v1.6a22.61,22.61,0,0,0,2.6,1.6.64.64,0,0,0,.6,0,.6.6,0,0,0,.3-.6A.55.55,0,0,0,188.43,61.8Z",
    transform: "translate(-0.81 -0.17)",
    fill: "#71c4ef"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanking);
export default __webpack_public_path__ + "static/media/banking.dfc748dc.svg";
export { ForwardRef as ReactComponent };